import { GET_SUB_CATEGORIES } from "constants/subCategories";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SUB_CATEGORIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
